// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateDTGProduct_closeButton__2Msgv"};